import { render, staticRenderFns } from "./nestedChildQuestion.vue?vue&type=template&id=1df6fab5&scoped=true"
import script from "./nestedChildQuestion.vue?vue&type=script&lang=js"
export * from "./nestedChildQuestion.vue?vue&type=script&lang=js"
import style0 from "./nestedChildQuestion.vue?vue&type=style&index=0&id=1df6fab5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df6fab5",
  null
  
)

export default component.exports